module.exports = __webpack_public_path__ + "img/skincare-img.827c1814.png";